import { createContext, useContext, type ReactNode } from "react";
import { useAuth, type AuthState, type AdminUser } from "@/hooks/useAuth";

type AuthContextValue = AuthState & {
  signIn: (email: string, password: string) => Promise<void>;
  signOut: () => Promise<void>;
  refresh: () => Promise<void>;
};

const AuthContext = createContext<AuthContextValue | null>(null);

export function AuthProvider({ children }: { children: ReactNode }) {
  const auth = useAuth();

  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
}

export function useAuthContext(): AuthContextValue {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuthContext must be used within AuthProvider");
  }
  return context;
}

export function useCurrentUser(): AdminUser {
  const context = useAuthContext();
  if (context.status !== "authenticated") {
    throw new Error("User is not authenticated");
  }
  return context.user;
}
